import React from "react";
import { Image, Container } from "react-bootstrap";
import { Link } from "react-router-dom";

import { WEB_TITLE } from "../constants/config_ui";
import logo from "../assets/images/logo-with-text.png";

export default function TemplatesArticles(props) {
  const { children } = props;

  return (
    <div className="articles">
      <header className="articles-header">
        <Container className="sub-container">
          <div className="logo-container">
            <Link className="logo" to="/" aria-label={`${WEB_TITLE} home`}>
              <Image src={logo} alt={WEB_TITLE} />
            </Link>
          </div>
          <div className="nav-container">
            <nav aria-label="Article navigation">
              <ul>
                <li>
                  <a className="active" href="#article">
                    Research
                  </a>
                </li>
                <li>
                  <a href="#database-preview">Database</a>
                </li>
                <li>
                  <a href="#methodology">Methodology</a>
                </li>
              </ul>
            </nav>
          </div>
        </Container>
      </header>
      <main>
        <Container className="content-container">{children}</Container>
      </main>
      <footer className="articles-footer">
        <Container>
          <span>{WEB_TITLE}</span>
          <span>
            Independent insights on Southeast Asia&apos;s startup ecosystem.
          </span>
        </Container>
      </footer>
    </div>
  );
}
